/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LossCauseResponseDto
 */
export interface LossCauseResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LossCauseResponseDto
     */
    lossCause: string;
    /**
     * 
     * @type {string}
     * @memberof LossCauseResponseDto
     */
    lossCauseName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LossCauseResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the LossCauseResponseDto interface.
 */
export function instanceOfLossCauseResponseDto(value: object): value is LossCauseResponseDto {
    if (!('lossCause' in value) || value['lossCause'] === undefined) return false;
    if (!('lossCauseName' in value) || value['lossCauseName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function LossCauseResponseDtoFromJSON(json: any): LossCauseResponseDto {
    return LossCauseResponseDtoFromJSONTyped(json, false);
}

export function LossCauseResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LossCauseResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lossCause': json['lossCause'],
        'lossCauseName': json['lossCauseName'],
        'isActive': json['isActive'],
    };
}

export function LossCauseResponseDtoToJSON(json: any): LossCauseResponseDto {
    return LossCauseResponseDtoToJSONTyped(json, false);
}

export function LossCauseResponseDtoToJSONTyped(value?: LossCauseResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lossCause': value['lossCause'],
        'lossCauseName': value['lossCauseName'],
        'isActive': value['isActive'],
    };
}

